const localization = {
  en: {
    medicationUppercase: 'MEDICATION',
    startedOnUppercase: 'Date Started On',
    orderedByUppercase: 'ORDERED BY',
    instructionsUppercase: 'INSTRUCTIONS'
  },
  es: {
    medicationUppercase: 'MEDICAMENTO',
    startedOnUppercase: 'FECHA DE INICIO',
    orderedByUppercase: 'ORDENADO POR',
    instructionsUppercase: 'INSTRUCCIONES'
  },
  keyMapping: {
    medicationUppercase: 'UFD_Medications_Text',
    startedOnUppercase: 'UFD_Date_Started_On',
    orderedByUppercase: 'UFD_Ordered_By',
    instructionsUppercase: 'UFD_Instructions_Text'
  }
}

export default localization

